import {HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable, Injector} from '@angular/core';
import { environment } from 'environments/environment';
import {SettingsService} from '../original-services/settings.service';
import {StorageService} from '../original-services/storage.service';

@Injectable({ providedIn: 'root' })
export class AuthenticationInterceptor implements HttpInterceptor {
    private storage: StorageService;
    private settings: SettingsService;

    constructor(private injector: Injector) {
        this.settings = injector.get(SettingsService);
        this.storage = injector.get(StorageService);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (req.url && req.url.indexOf('/auth/token/') < 0) {
            this.storage.lastActivity = new Date().getTime();
        }
        if (this.storage.accessToken && this.storage.accessToken != 'undefined'
             && !req.headers.has('authorization')
             && req.url.includes(environment.apiUrl)) {
            const authHeader = `Bearer ${this.storage.accessToken}`;
            const authReq = req.clone({headers: req.headers.set('Authorization', authHeader)});
            return next.handle(authReq);
        }

        return next.handle(req);
    }
}
